<template>
    <filters-wrapper :has-active-filters="props.hasActiveFilters" @submit="emit('submit')" @reset="emit('reset')">
        <template v-slot:panel>
            <FilterStatusToggle v-model="filters.active" @update:model-value="emit('submit')" />
        </template>
        <v-form class="table-filters">
            <v-row dense>
                <v-col cols="12" sm="6" md="3">
                    <v-text-field
                        v-model="filters.name"
                        :label="$t('name')"
                        hide-details
                        density="compact"
                        variant="outlined"
                        color="primary"
                        data-cy="name"
                        class="mb-4"
                    />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-select
                        v-model="filters.type"
                        :items="useShip"
                        :label="$t('type')"
                        clearable
                        density="compact"
                        variant="outlined"
                        color="primary"
                        data-cy="type"
                        hide-details
                        class="mb-4"
                    />
                </v-col>
            </v-row>
        </v-form>
    </filters-wrapper>
</template>

<script setup lang="ts">
    import type {ShipFilterType} from '~/utils/types/account/products/types'
    import {useShip} from '~/composables/form-helpers'

    const props = defineProps<{
        hasActiveFilters: boolean
    }>()

    const filters = defineModel<ShipFilterType>()
    const emit = defineEmits<{
        (e: 'submit' | 'reset'): void
    }>()
</script>
